import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
    selector: 'apply-selection',
    templateUrl: './apply-selection.component.html',
    styleUrls: ['./apply-selection.component.scss']
})
export class ApplySelectionComponent implements OnInit {
    @Input() positionX: string = "";
    @Input() positionY: string = "";

    @Output() selectAll: EventEmitter<boolean> = new EventEmitter();
    @Output() selectVacant: EventEmitter<boolean> = new EventEmitter();

    @Output() showAll: EventEmitter<boolean> = new EventEmitter();
    @Output() showVacant: EventEmitter<boolean> = new EventEmitter();

    constructor() { }

    ngOnInit() {
    }

    // Emit an event to copy selected cell's content to all other cells for this column.
    copySelectionToAll() {
        this.selectAll.emit(true);
    }

    // Emit an event to copy selected cell's content to vacant cells in this column.
    copySelectionToVacant() {
        this.selectVacant.emit(true);
    }

    // Emit an event to highlight all selected cells.
    showAllCells(status) {
        this.showAll.emit(status);
    }

    // Emit an event to highlight only vacant cells.
    showVacantCells(status) {
        this.showVacant.emit(status);
    }
}
